import { HTTP_OPTIONS, type Options } from '../../../http/server/path.ts';
import type { PathPattern } from './path-pattern.ts';

import { InternalPathPatternParser } from './internal/path-pattern-parser.ts';

export class PathPatternParser {
    #caseSensitive: boolean = true;
    #pathOptions: Options = HTTP_OPTIONS;

    get caseSensitive(): boolean {
        return this.#caseSensitive;
    }
    set caseSensitive(value: boolean) {
        this.#caseSensitive = value;
    }

    get pathOptions(): Options {
        return this.#pathOptions;
    }
    set pathOptions(value: Options) {
        this.#pathOptions = value;
    }

    public initFullPathPattern(pattern: string): string {
        return (pattern && !pattern.startsWith('/') ? '/' + pattern : pattern);
    }

    parse(pathPattern: string): PathPattern {
        return new InternalPathPatternParser(this).parse(pathPattern);
    }

    static readonly DEFAULT: PathPatternParser = new class extends PathPatternParser {
        override get caseSensitive(): boolean {
            return super.caseSensitive;
        }
        override set caseSensitive(_value: boolean) {
            this.#raiseError();
        }
        override get pathOptions(): Options {
            return super.pathOptions;
        }
        override set pathOptions(_value: Options) {
            this.#raiseError();
        }

        #raiseError(): never {
            throw new Error('PathPatternParser.DEFAULT is immutable');
        }
    };
}
